import { LocalId } from 'globalTypes'
import risikaAPI from 'services/api/helpers/risikaAPI'

/******************
 * Fetch from API *
 ******************/

export interface Highlight {
  classification: 'positive' | 'negative' | 'neutral'
  data: any
  description: string
  message: string
  title: string
  weight: number
}

export interface HighlightsResponse {
  fraudIndicators?: {
    [key: string]: Highlight
  }
}

type ResponseData = {
  data: {
    fraud_indicators: HighlightsResponse
  }
}

async function fraudIndicators({ id, country }: LocalId): Promise<HighlightsResponse> {
  const { data }: ResponseData = await risikaAPI.get(`/fraud_indicators/${id}`, {
    microservice: 'data',
    country,
  })

  return data?.fraud_indicators
}

export default fraudIndicators
